
import React, { Fragment } from 'react';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import {
    Button, Box, Typography, TextField, InputAdornment, FormGroup, Checkbox,
    FormControl, Switch, FormLabel, RadioGroup, Radio, FormControlLabel
} from "@mui/material";
import { Space, Row, Col } from "antd";
import CloseIcon from "../../../../../Shared/components/Icons/CloseIcon";
import { NavLink } from "react-router-dom";
import InfoMark from "../../../../../../assets/images/icon_actions/infoMark.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider, DesktopTimePicker } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import moment from 'moment';
import FileUpload from "../../../../../Shared/components/FileUpload";
import Every from "./Every";

export const LineForm = (props) => {
    const { classes, clsx, myProductdetails, lineForm, lineError, unitMesurementdetails, title, frequencyDetails, workflowDetails,
        shouldBlur, priceFocusList, productPrices, unitPriceFocusList, unitPriceList, handleProductPrice, headerView, handleEdit, handleAddMore,
        handleLineSubmit, view, changeHandler, idNamingConversion, customObject, handleProductChange, loader, lineId, productApi } = props;
    return (
        <Box
            className={clsx(classes.customForm, classes.removeUnderline)}
            component="form"
            autoComplete='off'
            onSubmit={(e) => handleLineSubmit(e)}>
            <div className={classes.customFormFlex}>
                <Row gutter={30}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Line {lineId} Details</Typography>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Row gutter={30}>
                            <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={16}>
                                <Row gutter={30}>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        {
                                            view ? <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productName || '---'}</Typography>
                                            </> : <AutoCompleteComponent
                                                name={["Products"]}
                                                heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                                { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                                details={myProductdetails}
                                                id={idNamingConversion('Product', 'customerProductSchedulingLine', 'DropDown')}
                                                parentValue={customObject(myProductdetails, lineForm?.productId)}
                                                onChange={(data) => handleProductChange(data)}
                                                position={"bottom"}
                                                searchType={(s) => productApi(s)}
                                                parentError={lineError?.productId || false}
                                                customClasses={classes.margin10t}
                                            />
                                        }
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product ID</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productId || '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Universal Product ID</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.universalProduct?.productId || '---'}</Typography>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                                <div className={clsx(classes.productImageUpload, classes.productSchedulingImageUpload, classes.dropDown)}>
                                    {
                                        lineForm?.product?.imageUri ? <FileUpload
                                            filePath={lineForm?.product?.imageUri || ''}
                                            alt={lineForm?.product?.productName}
                                            view={true}
                                        /> : <div className={clsx(classes.productImageUploadInner, classes.productImageUploadInnerView)}>
                                            <div className={classes.imageContainer}>No images uploaded</div></div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Status</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.status ? 'Active' : 'Inactive'}</Typography>
                            </> :
                                <FormControlLabel
                                    classes={{
                                        label: clsx(classes.textFieldLableColorCustom, classes.margin10b, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                    }}
                                    control={<Switch size='small'
                                        className={clsx(classes.customSwitch)}
                                        onChange={(e) => changeHandler(!lineForm?.status, 'status')}
                                    />}
                                    id={idNamingConversion('Status', 'customerProductSchedulingLine', 'Radio')}
                                    label="Status"
                                    labelPlacement="top"
                                    checked={lineForm?.status || false}
                                    className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Quantity</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.quantity || '---'}</Typography>
                            </> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                label={["Quantity ", <span key={"Quantity"} className={classes.colorRedRequired}> *</span>]}
                                type={'number'}
                                variant={'standard'}
                                value={lineForm?.quantity || ''}
                                id={idNamingConversion('Quantity', 'customerProductSchedulingLine', 'TextField')}
                                error={lineError?.quantity ? true : false}
                                helperText={lineError?.quantity}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                }}
                                onWheel={(e) => e.target.blur()}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => {
                                    if (e.target.value !== '') {
                                        if (e.target.value < 1) {
                                            changeHandler(e.target.value = 1, 'quantity');
                                        } else {
                                            changeHandler(e.target.value, 'quantity');
                                        }
                                    } else {
                                        changeHandler(e.target.value, 'quantity');
                                    }
                                }}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.unit?.name}
                                </Typography>
                            </> : <AutoCompleteComponent
                                name={["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={unitMesurementdetails}
                                id={idNamingConversion('Unit', 'customerProductSchedulingLine', 'DropDown')}
                                parentValue={customObject(unitMesurementdetails, lineForm?.unitId)}
                                onChange={(data) => changeHandler(data, 'unitId')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                                parentError={lineError?.unitId || false}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <div className={classes.customUnitPrice}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Amount</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineForm?.amount || '---'}
                                    </Typography>
                                </> : <>
                                    <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t)}
                                        label={["Amount ", <span key={"Amount"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        id={idNamingConversion('Amount', 'salesQuoteLine', 'TextField')}
                                        error={lineError?.amount ? true : false}
                                        helperText={lineError?.amount || false}
                                        value={lineForm?.amount || ''}
                                        fullWidth
                                        onKeyDown={(e) => shouldBlur(e)}
                                        onWheel={(e) => e.target.blur()}
                                        InputProps={{
                                            startAdornment: <InputAdornment className={clsx(classes.textFieldColor)} position="start">₹ </InputAdornment>,
                                            classes: {
                                                input: classes.textFieldColor,
                                            },
                                            endAdornment: productPrices?.lastprice && !unitPriceList && lineForm?.productId && lineForm?.price &&
                                                lineForm?.pricePerUnit === productPrices?.lastprice[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.price ?
                                                <InputAdornment className={clsx(classes.lastSalesPrice)} position="end">
                                                    <div className={classes.infoSuggestion}><img alt="Last Sales Price" src={InfoMark} /> <span>Last Sales Price</span></div></InputAdornment>
                                                : false
                                        }}
                                        inputProps={{
                                            step: "any"
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onFocus={() => priceFocusList(true)}
                                        onChange={(e) =>
                                            e.target.value !== '' ?
                                                e.target.value < 0 ?
                                                    changeHandler((e.target.value = 0), 'amount') : changeHandler(e.target.value, 'amount') : changeHandler(e.target.value, 'amount')}
                                    />
                                    {
                                        productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && unitPriceFocusList && lineForm?.productId && <div className={classes.suggestionBox}>
                                            <CloseIcon onClick={() => priceFocusList(false)} className={classes.productpriceCloseIcon} />
                                            <div className={classes.suggestionBoxTitle}><div className={classes.infoSuggestion}><img alt="Last Sales Price" src={InfoMark} /> <span>Last Sales Price</span></div></div>
                                            <div className={classes.historicalData}>
                                                {
                                                    productPrices?.lastprice && Object.keys(productPrices?.lastprice).length > 0 && Object?.entries(productPrices?.lastprice)?.map(([key, value]) => (
                                                        <NavLink to="#" onClick={() => handleProductPrice(key)} key={key}>₹ {value?.price} per {key}</NavLink>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Row>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.typographyHeader, classes.bold, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Use Latest Price</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.useLatestPrice ? 'Yes' : 'No'}</Typography>
                                    </> :
                                        <FormControlLabel
                                            classes={{
                                                label: clsx(classes.textFieldLableColorCustom, classes.margin10b, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                            }}
                                            control={<Switch size='small'
                                                className={clsx(classes.customSwitch)}
                                                onChange={(e) => changeHandler(!lineForm?.useLatestPrice, 'useLatestPrice')}
                                            />}
                                            id={idNamingConversion('Use Latest Price', 'customerProductSchedulingLine', 'Radio')}
                                            label="Use Latest Price"
                                            labelPlacement="top"
                                            checked={lineForm?.useLatestPrice || false}
                                            className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                        />
                                }
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                {
                                    view ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.typographyHeader, classes.bold, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Batch Automate</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.batch_automate ? 'Yes' : 'No'}</Typography>
                                    </> :
                                        <FormControlLabel
                                            classes={{
                                                label: clsx(classes.textFieldLableColorCustom, classes.margin10b, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                            }}
                                            control={<Switch size='small'
                                                className={clsx(classes.customSwitch)}
                                                onChange={(e) => changeHandler(!lineForm?.batch_automate, 'batch_automate')}
                                            />}
                                            id={idNamingConversion('Batch Automate', 'customerProductSchedulingLine', 'Radio')}
                                            label="Batch Automate"
                                            labelPlacement="top"
                                            checked={lineForm?.batch_automate || false}
                                            className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                        />
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            view ?
                                <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Recurring Actions</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineForm?.workflow?.action || ''}   {lineForm?.workflow?.actionStatus || ''}
                                    </Typography>
                                </> : <AutoCompleteComponent
                                    name={["Work Flow ", <span key={"Work Flow"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={workflowDetails}
                                    id={idNamingConversion('Work Flow', 'customerProductSchedulingLine', 'DropDown')}
                                    parentValue={customObject(workflowDetails, lineForm?.workflowId)}
                                    onChange={(data) => changeHandler(data, 'workflowId')}
                                    position={"bottom"}
                                    parentError={lineError?.workflowId || false}
                                    customClasses={classes.margin10t}
                                />

                        }
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Action Frequency</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.scheduleFrequency?.name || '---'}</Typography>
                            </> : <AutoCompleteComponent
                                name={["Action Frequency ", <span key={"Amount"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={frequencyDetails}
                                id={idNamingConversion('Action Frequency', 'customerProductSchedulingLine', 'DropDown')}
                                parentValue={customObject(frequencyDetails, lineForm?.scheduleFrequencyId)}
                                onChange={(data) => changeHandler(data, 'scheduleFrequencyId')}
                                position={"bottom"}
                                parentError={lineError?.scheduleFrequencyId || false}
                                customClasses={classes.margin20t}
                            />
                        }
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                            {
                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Start Date</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {lineForm.start_date ? moment(lineForm.start_date).format('DD MMM YYYY') : '---'}
                                        </Typography>
                                    </> :
                                    <LocalizationProvider
                                        dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            tabIndex={-1}
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={lineForm?.start_date || null}
                                            label={["Start Date ", <span key={"Start Date"} className={classes.colorRedRequired}> *</span>]}
                                            PopperProps={{
                                                className: classes.dateAdjust,
                                            }}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    id: idNamingConversion('Start Date', 'customerProductSchedulingLine', 'TextField'),
                                                    autoComplete: 'one-time-code',
                                                    error: lineError?.start_date ? true : false,
                                                    helperText: lineError?.start_date
                                                },
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue, newError) => {
                                                if (newError?.validationError || newValue === null) {
                                                    changeHandler(new Date(), 'start_date');
                                                } else {
                                                    changeHandler(newValue, 'start_date');
                                                }
                                            }}

                                        />
                                    </LocalizationProvider>
                            }
                        </div>
                    </Col>
                    {
                        lineForm?.scheduleFrequency?.repeatType !== 'Daily' && <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            {lineError?.every && <p className={classes.customError} style={{ margin: "10px 0 0 0" }}>{lineError?.every}</p>}
                            <Every
                                clsx={clsx}
                                FormGroup={FormGroup}
                                Checkbox={Checkbox}
                                classes={classes}
                                FormLabel={FormLabel}
                                FormControl={FormControl}
                                RadioGroup={RadioGroup}
                                FormControlLabel={FormControlLabel}
                                Radio={Radio}
                                UnSelectedIcon={UnSelectedIcon}
                                SelectedIcon={SelectedIcon}
                                TextField={TextField}
                                {...props}
                                idNamingConversion={(name, place = 'menu', fieldType = '') => idNamingConversion(name, place, fieldType)}
                                frequency={lineForm?.scheduleFrequency?.repeatType} />

                        </Col>
                    }
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                            {
                                view ?
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>End Date</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {lineForm?.end_date ? moment(lineForm.end_date).format('DD MMM YYYY') : '---'}
                                        </Typography>
                                    </> :
                                    <LocalizationProvider
                                        dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={lineForm?.end_date || null}
                                            label="End Date"
                                            PopperProps={{
                                                className: classes.dateAdjust,
                                            }}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    id: idNamingConversion('End Date', 'customerProductSchedulingLine', 'TextField'),
                                                    autoComplete: 'one-time-code'
                                                },
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue, newError) => {
                                                if (newError?.validationError || newValue === null) {
                                                    changeHandler(null, 'end_date');
                                                } else {
                                                    changeHandler(newValue, 'end_date');
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                            }
                        </div>
                        {
                            view ?
                                <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Schedule Time</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {lineForm?.schedule_time ? moment(lineForm.schedule_time).format('HH:mm') : '---'}
                                    </Typography>
                                </> :
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider
                                        dateAdapter={AdapterDateFns}>
                                        <DesktopTimePicker
                                            ampm={false}
                                            PopperProps={{
                                                className: classes.textFieldColor,
                                            }}
                                            label="Schedule Time"
                                            format="HH:mm"
                                            value={lineForm?.schedule_time || null}
                                            onChange={(newValue) => changeHandler(newValue, 'schedule_time')}
                                        />
                                    </LocalizationProvider>
                                </div>

                        }

                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center" size={[10, 10]}>
                    {
                        !headerView && <>
                            {
                                view ? <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink> :
                                    <>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: loader })}>
                                            {
                                                title === 'Edit' ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            title === 'Add' && <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: loader })}
                                                onClick={(e) => handleAddMore(e)}
                                            >Add More</Button>
                                        }
                                    </>
                            }
                        </>
                    }
                </Space>
            </div>
        </Box>
    )
}